import {RepositoryFactory} from '../../api/RepositoryFactory';

export default {
    actions: {
        GET_SUBJECTS: async (context, payload) => {
            await RepositoryFactory.get('subjects').get(payload).then((res) => {
                context.commit('SET_SUBJECTS', res.data.courses)
            });
        }
    },

    mutations: {
        SET_SUBJECTS: (state, payload) => {
            state.subjects = payload;
        }
    },

    state: {
        subjects: []
    },

    getters: {
        SUBJECTS: state => {
            return state.subjects;
        }
    }
}